import VueRouter from "vue-router"
import Vue from 'vue'

const Index = () =>  import('../components/index.vue')
const Charge = () =>  import('../components/charge.vue')
const Balance = () =>  import('../components/balance.vue')
const Echfation = () =>  import('../components/echfation.vue')
const Elall = () =>  import('../components/elall.vue')
const Element = () =>  import('../components/element.vue')
const Management = () =>  import('../components/management.vue')
const Mentw = () =>  import('../components/mentw.vue')
const Pay = () =>  import('../components/pay.vue')
const Payment = () =>  import('../components/payment.vue')
const Pays = () =>  import('../components/pay-really.vue')
const State = () =>  import('../components/state.vue')
const Wateragain = () =>  import('../components/wateragain.vue')
const Waterelall = () =>  import('../components/waterelall.vue')
const Waterstate = () =>  import('../components/waterstate.vue')
const Watermentw = () =>  import('../components/watmentw.vue')
const Waters = () =>  import('../components/water-really.vue')
const Allment = () =>  import('../components/allment.vue')
const Default = () =>  import('../components/default.vue')
const Room = () =>  import('../components/room.vue')
const About = () =>  import('../components/about.vue')
const Feed = () =>  import('../components/feed.vue')
const Record = () =>  import('../components/record.vue')
const RechargeBalance = () =>  import('../components/rechargeBalance.vue')
const Cost = () =>  import('../components/cost.vue')



const routes = [
	{
	  path: '/', 
	  redirect: '/index',
	  meta: {
		  keepAlive: true,
		  index:1
	  }
	},
	{
		path:'/index',
		component:Index,
		meta: {
			keepAlive: true,
			index:1
		}
	},

	{
		path:'/charge',
		component:Charge,
		meta: {
			keepAlive: true,
			index:2
		}
	},
	{
		path:'/balance',
		component:Balance,
		meta: {
			keepAlive: true,
			index:3
		}
	},
	{
		path:'/echfation',
		component:Echfation,
		meta: {
			keepAlive: true,
			index:3
		}

	},
	{
		path:'/elall',
		component:Elall,
		meta: {
			keepAlive: true,
			index:2
		}
	},
	{
		path:'/element',
		component:Element,
		meta: {
			keepAlive: true,
			index:3
		}
	},

	{
		path:'/management',
		component:Management,
		meta: {
			keepAlive: true, // 不需要缓存
			index:2
		}

	},
	{
		path:'/mentw',
		component:Mentw,
		meta: {
			keepAlive: true, // 不需要缓存
			index:2
		}

	},
	{
		path:'/pay',
		component:Pay,
		meta: {
			keepAlive: true, // 不需要缓存
			index:2
		}

	},
	
	{
		path:'/payment',
		component:Payment,
		meta: {
			keepAlive: true, // 不需要缓存
			index:3
		}

	},
	{
		path:'/pay-really',
		component:Pays,
		meta: {
			keepAlive: true, // 不需要缓存
			index:3
		}

	},
	{
		path:'/state',
		component:State,
		meta: {
			keepAlive: true, // 不需要缓存
			index:4
		}

	},
	{
		path:'/wateragain',
		component:Wateragain,
		meta: {
			keepAlive: true, // 不需要缓存
			index:3
		}

	},{
		path:'/waterelall',
		component:Waterelall,
		meta: {
			keepAlive: true, // 不需要缓存
			index:2
		}

	},
	{
		path:'/waterstate',
		component:Waterstate,
		meta: {
			keepAlive: true, // 不需要缓存
			index:4
		}

	},
	{
		path:'/watmentw',
		component:Watermentw,
		meta: {
			keepAlive: true, // 不需要缓存
			index:2
		}

	},
	{
		path:'/water-really',
		component:Waters,
		meta: {
			keepAlive: true, // 不需要缓存
			index:3
		}

	},
	{
		path:'/allment',
		component:Allment,
		meta: {
			keepAlive: true, // 不需要缓存
			index:2
		}

	},{
		path:'/default',
		component:Default,
		meta: {
			keepAlive: true, // 不需要缓存
			index:2
		}

	},{
		path:'/room',
		component:Room,
		meta: {
			keepAlive: true, // 不需要缓存
			index:2
		}

	},{
		path:'/feed',
		component:Feed,
		meta: {
			keepAlive: true, // 不需要缓存
			index:2
		}

	},{
		path:'/about',
		component:About,
		meta: {
			keepAlive: true, // 不需要缓存
			index:2
		}

	},{
		path:'/rechargeBalance',
		component:RechargeBalance,
		meta: {
			keepAlive: true, // 不需要缓存
			index:2
		}

	},{
		path:'/record',
		component:Record,
		meta: {
			keepAlive: true, // 不需要缓存
			index:2
		}

	},{
		path:'/cost',
		component:Cost,
		meta: {
			keepAlive: true, // 不需要缓存
			index:2
		}

	},
	
]

Vue.use(VueRouter)



const router = new VueRouter({
	routes
})

export default router